import React, { useState, useEffect } from 'react'
import "./logohome.css"
import newLogo from './rebrand.png';
import PhoneIcon from '@mui/icons-material/Phone';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link, useLocation } from 'react-router-dom'



const ITEM_HEIGHT = 48;

export default function LogoHome() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const location = useLocation();
  const [active, setActive] = useState("");

  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

const options = [
  <Link className={active === '/' ? "active": "link"} to="/">Home</Link>,
  <Link className={active === '/properties' ? "active": "link"} to="/properties">Properties</Link>,
  <Link className={active === '/staff' ? "active": "link"} to="/staff">Staff</Link>,
  <Link className={active === '/about' ? "active": "link"} to="/about">About</Link>,
  <Link className={active === '/contact' ? "active": "link"} to="/contact">Contact</Link>,
];

  return (
    <div className='logohome'>
        <div className="marginc">
          <div className="hamburgermenu">
          <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} selected={option === options[0]} onClick={handleClose}>
            {option}
          </MenuItem>
        ))}
      </Menu>
          </div>
        <div className="logo">
            <img src={newLogo} alt="logo" width="130" height="130" />
        </div>
        {/*<div className="logotext">*/}
        {/*    <h1>PARAGON<br/> <span style={{fontSize: "15px"}}>HOMES SOLUTIONS</span></h1>*/}
        {/*    </div>*/}
            <nav>
                <li><Link className={active === '/' ? "active": "link"} to="/">Home</Link></li>
                <li><Link className={active === '/properties' ? "active": "link"} to="/properties">Properties</Link></li>
                <li><Link className={active === '/staff' ? "active": "link"} to="/staff">Staff</Link></li>
                <li><Link className={active === '/about' ? "active": "link"} to="/about">About</Link></li>
                <li style={{marginRight: "40px"}}><Link className={active === '/contact' ? "active": "link"} to="/contact">Contact</Link></li>
                <li><PhoneIcon style={{color: "#eb4034"}}/></li>
                <li style={{fontWeight: "bold"}}>+254104141843</li>
            </nav>
            </div>
    </div>
  )
}
